export default "__VITE_ASSET__Bik6GiFr__"